import React from "react";
import { Feature } from "../../components";
import "./whatScrobits.css";

const WhatScrobits = () => (
  <div>
    <div id="about-scrobits"></div>

    <section
      className="scrobits__whatScrobits section__margin"
      // id="about-scrobits"
      data-aos="zoom-in"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
    >
      <div className="scrobits__whatScrobits-feature">
        <Feature
          title="About Scrobits"
          text="Scrobits is a certified digital products and online experiences company. We are a team of artists, engineers, writers and designers, thinkers and learners, dreamers and tech visionaries all working toward the same goal of creating the world's finest digital products, 
solutions, and experiences.  How do we go about doing it? Well, it's simple! We all do our best to supply right-sized technology as accurately and tastefully as possible."
          img={"/assets/img/icon.png"}
        />
      </div>
      <div className="scrobits__whatScrobits-heading">
        <h1 className="gradient__text">
          Build scalable web and mobile Apps with India's top engineers
        </h1>
      </div>
      <div className="scrobits__whatScrobits-container">
        <Feature
          title="Powerful ownership"
          text="We don’t blindly follow the requirements. From top to bottom, we have a direct impact on the project’s direction."
        />
        <Feature
          title="Consultancy Attitude"
          text="We are engaged in the full business process. Our goal is to solve real problems through excellent communication."
        />
        <Feature
          title="Outcome-oriented"
          text="We build adaptable digital products, not raw features. Our focus is on making your business succeed in the long term."
        />
      </div>
    </section>
  </div>
);

export default WhatScrobits;
